<ng-container>
    <div class="sub-chrome-container">
        <div class="title-area">
            <span class="h1-light text-ellipsis">{{screenInfo.name}}</span>
        </div>
        <div class="operation-box">
            <button tam-button tamType="primary" tamSize="normal" class="btn" (click)="onNewEventClick()">New
                Event</button>
        </div>
    </div>
</ng-container>